import {
  AppBar,
  AppBarSection,
  AppBarSpacer,
} from "@progress/kendo-react-layout";
import LoginGovLogin from "components/LoginGovLogin";
import { useAppSelector } from "hooks/redux";
import { Image } from "react-bootstrap";
import VendorRfiNavBar from "./VendorRfiNavBar";
import { selectAppConfig } from "store/appConfigSlice";
import { VendorUserType } from "auth/VendorAuth/vendorUserSlice";

interface IVendorRfiAppBarProps {
  user?: VendorUserType;
  readOnly?: boolean;
  onResponseDeleted?: () => void;
}

const VendorRfiAppBar = (props: IVendorRfiAppBarProps) => {
  // Hooks
  const appConfig = useAppSelector(selectAppConfig);

  return (
    <>
      <AppBar themeColor="inherit">
        <AppBarSpacer
          style={{
            width: 4,
          }}
        />

        <AppBarSection>
          <>
            {appConfig?.logo && (
              <img
                className="logo k-mr-2"
                src={`data:image/png;base64,${appConfig?.logo}`}
                alt="application unison"
              />
            )}

            {!appConfig?.logo && (
              <Image
                src="/image/logoUnison.svg"
                alt="Unison logo"
                className="logo k-mr-2"
              />
            )}
            <div className="appName">RFI Assistant</div>
          </>
        </AppBarSection>

        <AppBarSpacer />
        <AppBarSection className="user-avatar">
          <div className="k-mr-3" style={{ textAlign: "right" }}>
            <LoginGovLogin />
          </div>
        </AppBarSection>
      </AppBar>

      <VendorRfiNavBar {...props} />
    </>
  );
};

export default VendorRfiAppBar;
